module.exports = __webpack_public_path__ + "static/img/shiyan_logo.8d17724.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/shiyan_logo.jpg
// module id = Sj3C
// module chunks = 1